<template>
  <div class="page-container base-batch-list">
    <div class="page-title-container">
      <h1 class="page-title">Vendedores</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-flex d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por nombres y apellidos, código de colaborador"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />

              <div class="text-right mt-2 mt-md-0">
                <b-button
                  :to="{ name: 'celulares-sellers-create' }"
                  variant="none"
                  class="button button-primary ml-md-2"
                  v-if="$can('manage', 'cargos_vendedores_agregar')"
                >Agregar
                </b-button
                >
              </div>
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="mb-0">
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Código de colaborador</span>
            </div>

            <div>
              <span>Nombres y Apellidos</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.code }}</span>
                </div>
                <div>
                  <span>{{ o.name }} {{ o.surname }}</span>
                </div>
                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link
                  :to="{
                    name: 'celulares-sellers-edit',
                    params: { id: o.id },
                  }"
                  class="mr-2"
                  v-if="$can('manage', 'cargos_vendedores_editar')"
                >Editar
                </router-link
                >
                <a href="" @click.prevent="openChangeStatus(o)" class="mr-2"
                   v-if="$can('manage', 'cargos_vendedores_activar')">{{ getStatus(o.status).action }}</a>
                <a href="" @click.prevent="openDelete(o)" class="mr-2"
                   v-if="$can('manage', 'cargos_vendedores_eliminar')">Eliminar</a>
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                    >Celular:</span
                    >
                    <span>{{ o.businessPhone }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                    >Correo electrónico:</span
                    >
                    <span>{{ o.businessEmail }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                    >Supervisor:</span
                    >
                    <span></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                    >Zonales:</span
                    >
                    <span>{{ o.zonales.map(zonal => zonal.description).join(', ') }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                    >Estado:</span
                    >
                    <span :class="`badge ${getStatus(o.status).color}`">{{
                        getStatus(o.status).label
                      }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
          <tr>
            <th>Código de <br> colaborador</th>
            <th>Nombres y Apellidos</th>
            <th>Celular</th>
            <th>Correo electrónico</th>
            <th>Supervisor</th>
            <th>Zonales</th>
            <th>Estado</th>
            <th class="pr-md-3"
                v-if="$can('manage', 'cargos_vendedores_editar') ||
                        $can('manage', 'cargos_vendedores_activar') ||
                        $can('manage', 'cargos_vendedores_eliminar')">Opciones</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="o in list" :key="o.id">
            <td class="cell-center px-1">{{ o.code }}</td>
            <td>{{ o.name }} {{ o.surname }}</td>
            <td class="cell-center">{{ o.businessPhone }}</td>
            <td class="cell-center">{{ o.businessEmail }}</td>
            <td class="cell-center"></td>
            <td class="cell-center">{{ o.zonales.map(zonal => zonal.description).join(', ') }}</td>
            <td class="cell-center"><span :class="`badge ${getStatus(o.status).color}`">{{
                getStatus(o.status).label
              }}</span></td>
            <td class="cell-center d_option pr-md-2 position-relative"
                v-if="$can('manage', 'cargos_vendedores_editar') ||
                        $can('manage', 'cargos_vendedores_activar') ||
                        $can('manage', 'cargos_vendedores_eliminar')">
              <DropdownTable>
                <template v-slot:dropdown-content>
                  <DropdownItem
                    text="Editar"
                    v-if="$can('manage', 'cargos_vendedores_editar')"
                    :to="{
                        name: 'celulares-sellers-edit',
                        params: { id: o.id },
                      }"
                  />
                  <DropdownItem
                    :text="getStatus(o.status).action"
                    v-if="$can('manage', 'cargos_vendedores_editar')"
                    @click="openChangeStatus(o)"
                  />
                  <DropdownItem
                    text="Eliminar"
                    v-if="$can('manage', 'cargos_vendedores_eliminar')"
                    @click="openDelete(o)"
                  />
                </template>
              </DropdownTable>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
          v-if="list.length"
        />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">No se encontraron vendedores que coincidan con los criterios seleccionados.</p>
        </div>
      </div>
    </div>
    <ConfirmationModal
      :show="confirmationModal.show"
      @hide="closeConfirmationModal"
      :data="confirmationModal"
      @confirm="confirmModal"
    />
  </div>
</template>

<script>
import { EmployeeService } from "@/core/services";

import {
  Alert,
  Constants,
  DropdownItem,
  DropdownTable,
  FilterMenu,
  FilterMixin,
  PaginationMixin,
  SearchBar,
  Util,
  ConfirmationModal,
  ConfirmationModalMixin,
} from "wize-admin";

import { Constants as LocalConstants } from "@/core/utils";
import geoDataMixin from "@/core/Mixins/geoDataMixin";

export default {
  components: {
    SearchBar,
    DropdownTable,
    DropdownItem,
    FilterMenu,
    ConfirmationModal,
  },
  data() {
    return {
      list: [],
      tooltipType: null,
      pageSize: 100,
      zonalList: [],
      filterOptions: [
        {
          label: "Estado",
          key: "status",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.EmployeeStatus.ACTIVE,
            LocalConstants.EmployeeStatus.INACTIVE,
          ]
        },
        {
          label: "Zonal",
          key: "zonalIds",
          type: Constants.TypeFilters.MULTIPLE,
          options: []
        },
      ],
    };
  },
  mixins: [FilterMixin, PaginationMixin, ConfirmationModalMixin, geoDataMixin],
  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);

        const params = {
          page: this.page - 1,
          size: this.pageSize,
          sort: "code,asc",
        };

        const data = {search: this.search, ...this.filters, position: LocalConstants.EmployeePosition.SELLER.key};
        const response = await EmployeeService.list(data, params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getStatus(key) {
      return Util.searchValue(key, LocalConstants.EmployeeStatus);
    },
    async changeStatus() {
      try {
        await this.$store.dispatch("app/loading", true);

        let status = this.selectedOption.status;

        if (status === LocalConstants.EmployeeStatus.ACTIVE.key) {
          status = LocalConstants.EmployeeStatus.INACTIVE.key;
        } else if (status === LocalConstants.PdvStatus.INACTIVE.key) {
          status = LocalConstants.EmployeeStatus.ACTIVE.key;
        }

        await EmployeeService.changeStatus(this.selectedOption.id, status);
        await this.loadData();
        Alert.success("Estado actualizado correctamente");
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    async deleteSeller() {
      try {
        await this.$store.dispatch("app/loading", true);

        await EmployeeService.delete(this.selectedOption.id);
        await this.loadData();
        Alert.success("Vendedor eliminado correctamente");
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    openChangeStatus(o) {
      this.selectedOption = o;
      this.openConfirmationModal({
        title: "Cambiar estado",
        description: "¿Está seguro que desea cambiar el estado?",
        acceptText: "Aceptar",
        action: "update",
      });
    },
    openDelete(o) {
      this.selectedOption = o;
      this.openConfirmationModal({
        title: "Cambiar estado",
        description: "¿Está seguro que desea eliminar el vendedor?",
        acceptText: "Aceptar",
        action: "delete",
      });
    },
    confirmModal() {
      this.closeConfirmationModal();
      if (this.confirmationModal.action === "update") this.changeStatus();
      else if (this.confirmationModal.action === "delete") this.deleteSeller();
    },
  },
  async mounted() {
    await this.loadData();
    await this.getZonalList();
    const zonalOptions = this.filterOptions.find((o) => o.key === "zonalIds");
    zonalOptions.options = this.zonalList;
  },
  async created() {
  },
};
</script>

<style lang="stylus" scoped></style>
